import Entity from './entity'
export default class Vessel extends Entity<number> {
    name: string;
    immoNumber: string;
    mmsiNumber: string;
    type: number | null;
    flagId: number | null;
    childVesselId: number | null;
}
